<div class="rps-sheet">

  <!-- ════════════════════════════════════════════════════════════════════════
       FULL-SCREEN CALENDAR VIEW (mirrors Map Display Filter)
       ════════════════════════════════════════════════════════════════════════ -->
  <div class="cal-fullscreen" *ngIf="showCalendar">
    <div class="cal-topbar">
      <button class="cal-close-btn" (click)="closeCalendar()" aria-label="Close calendar">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <span class="cal-title">SELECT DATE RANGE</span>
      <button class="cal-save-btn" (click)="saveCalendar()">Save</button>
    </div>
    <div class="cal-range-display">
      {{ getFullDateRange() }}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" style="margin-left:8px">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </svg>
    </div>
    <div class="cal-body">
      <mat-calendar [selected]="selectedRange" [minDate]="minDate" [maxDate]="maxDate"
        (selectedChange)="onDateSelected($event)">
      </mat-calendar>
    </div>
    <p class="rps-error" *ngIf="dateRangeError">{{ dateRangeError }}</p>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       MAIN SHEET CONTENT
       ════════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="!showCalendar">

  <div class="rps-drag-handle"></div>

  <!-- Title -->
  <div class="rps-title-row">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polygon points="10 8 16 12 10 16 10 8"></polygon>
    </svg>
    <span class="rps-title">Trip Replay Filters</span>
  </div>

  <!-- Tab Bar -->
  <div class="rps-tab-bar">
    <button class="rps-tab" [class.rps-tab--active]="activeTab === 0" (click)="activeTab = 0">Timeline</button>
    <button class="rps-tab" [class.rps-tab--active]="activeTab === 1" (click)="activeTab = 1">View</button>
  </div>

  <!-- Tab Content -->
  <div class="rps-content">

    <!-- Timeline tab -->
    <ng-container *ngIf="activeTab === 0">
      <button class="rps-option" *ngFor="let p of presets; let i = index"
        [class.rps-option--selected]="presetIndex === p.index"
        (click)="selectPreset(p.index)">
        <svg class="rps-option-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <ng-container *ngIf="i === 0">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </ng-container>
          <ng-container *ngIf="i === 1">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
            <line x1="8" y1="14" x2="8" y2="14" stroke-width="3"></line>
            <line x1="12" y1="14" x2="12" y2="14" stroke-width="3"></line>
            <line x1="16" y1="14" x2="16" y2="14" stroke-width="3"></line>
          </ng-container>
          <ng-container *ngIf="i === 2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
            <line x1="8" y1="14" x2="16" y2="14"></line>
            <line x1="8" y1="18" x2="16" y2="18"></line>
          </ng-container>
        </svg>
        <span class="rps-option-label">{{ p.label }}</span>
        <svg *ngIf="presetIndex === p.index" class="rps-check" viewBox="0 0 24 24" fill="none"
          stroke="#007AFF" stroke-width="2.5" stroke-linecap="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </button>

      <button class="rps-option" [class.rps-option--selected]="presetIndex === -1"
        (click)="openCustomRange()">
        <svg class="rps-option-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
          <line x1="12" y1="15" x2="12" y2="19"></line>
          <line x1="10" y1="17" x2="14" y2="17"></line>
        </svg>
        <span class="rps-option-label">
          {{ presetIndex === -1 ? customRangeLabel : 'Custom Range' }}
        </span>
        <svg *ngIf="presetIndex === -1" class="rps-check" viewBox="0 0 24 24" fill="none"
          stroke="#007AFF" stroke-width="2.5" stroke-linecap="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <svg *ngIf="presetIndex !== -1" class="rps-chevron" viewBox="0 0 24 24" fill="none"
          stroke="#8E8E93" stroke-width="2" stroke-linecap="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      <p class="rps-error" *ngIf="dateRangeError">{{ dateRangeError }}</p>
    </ng-container>

    <!-- View tab -->
    <ng-container *ngIf="activeTab === 1">
      <button class="rps-option" *ngFor="let s of sources; let i = index"
        [class.rps-option--selected]="sourceIndex === i"
        (click)="sourceIndex = i">
        <svg class="rps-option-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <ng-container *ngIf="i === 0">
            <polyline points="9 11 12 14 22 4"></polyline>
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
          </ng-container>
          <ng-container *ngIf="i === 1">
            <path d="M3 17l4-8 4 4 2-2 5 6"></path>
            <circle cx="18" cy="5" r="2"></circle>
          </ng-container>
          <ng-container *ngIf="i === 2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </ng-container>
        </svg>
        <span class="rps-option-label">{{ s.label }}</span>
        <svg *ngIf="sourceIndex === i" class="rps-check" viewBox="0 0 24 24" fill="none"
          stroke="#007AFF" stroke-width="2.5" stroke-linecap="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </button>
    </ng-container>
  </div>

  <!-- Save toggle -->
  <div class="rps-save-row">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
    </svg>
    <span class="rps-save-label">Save filters for next time</span>
    <label class="rps-toggle">
      <input type="checkbox" [(ngModel)]="saveFilters" />
      <span class="rps-toggle-track"></span>
    </label>
  </div>

  <!-- Save & Apply -->
  <button class="rps-save-btn" (click)="save()">
    {{ hasChanges ? 'Save & Apply' : 'Close' }}
  </button>

  </ng-container><!-- end main sheet -->
</div>
